import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { PageNotFoundComponent } from "./page-not-found/page-not-found.component";
import { SurveyDisplayComponent } from "./survey-display/survey-display.component";
import {OnboardingComponent} from "./onboarding/onboarding.component";
import { ArticleDisplayComponent } from "./article-display/article-display.component";

const routes: Routes = [
  { path: "article", component: ArticleDisplayComponent },
  { path: "survey", component: SurveyDisplayComponent },
  { path: "onboarding", component: OnboardingComponent },
  { path: "**", component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
